import React, { useEffect, useMemo, useRef } from 'react';
import { RouteComponentProps, useLocation } from '@reach/router';
import { Box, Button, Container, Link, VStack } from '@chakra-ui/react';

import HomeHeader from './HomeHeader';
import HomeInfo from './HomeInfo';
import HomeWorld from './HomeWorld';
import HomeCustomers from './HomeCustomers';
import HomeQuotes from './HomeQuotes';

const Home: React.FC<RouteComponentProps> = () => {
  const { state: locationState } = useLocation();
  const productRef = useRef<HTMLDivElement>(null);
  const customersRef = useRef<HTMLDivElement>(null);
  const otherServicesRef = useRef<HTMLDivElement>(null);
  const requestDemoFormRef = useRef<HTMLDivElement>(null);
  const scrollRefs: Record<
    string,
    React.RefObject<HTMLElement> | undefined
  > = useMemo(
    () => ({
      product: productRef,
      customers: customersRef,
      otherServices: otherServicesRef,
      demo: requestDemoFormRef,
    }),
    [],
  );
  useEffect(() => {
    if (typeof locationState === 'object' && locationState !== null) {
      const state = locationState as {
        scrollTo?: string | null;
      };
      if (!state.scrollTo) {
        return;
      }
      const scrollToRef = scrollRefs[state.scrollTo];
      if (scrollToRef) {
        setTimeout(() => {
          window.scrollTo({
            left: 0,
            top: scrollToRef.current?.offsetTop,
            behavior: 'smooth',
          });
        }, 0);
      }
    }
  }, [locationState, scrollRefs]);
  return (
    <>
      <Box ref={productRef} />
      <Container
        maxW="container.xl"
        display="flex"
        flexGrow={1}
        flexDir="column"
      >
        <VStack spacing={6}>
          <HomeHeader />
          <HomeInfo />
          <Box pt={4} pb={6}>
            <Button
              as={Link}
              colorScheme="yellow"
              variant="solid"
              href="https://datapoints-static-files.s3.eu-west-1.amazonaws.com/files/the_datapoints_brochure.pdf"
              target="_default"
            >
              Download Brochure
            </Button>
          </Box>
          <HomeWorld />
          <Box ref={customersRef}>
            <HomeCustomers />
          </Box>
          <HomeQuotes />
          <Button
            as={Link}
            colorScheme="yellow"
            variant="solid"
            href="https://datapoints-static-files.s3.eu-west-1.amazonaws.com/files/the_case_studies.pdf"
            target="_default"
          >
            Download case studies
          </Button>
          <Button
            as={Link}
            colorScheme="yellow"
            variant="solid"
            href="https://www.timeshighereducation.com/our-solutions/enquire-now"
            target="_default"
          >
            Enquire Now
          </Button>
        </VStack>
      </Container>
      <Box ref={otherServicesRef} />
    </>
  );
};

export default Home;
